import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './store'
import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react'
import { monkeyPatchGraphqlCalls } from './utils/GraphQLInterceptor'
import { Amplify } from 'aws-amplify'
import awsconfig from './aws-config' // this is where we store the links to the APIs and Cognito

// Create growthbook instance
const gb = new GrowthBook({})

// Pathing Amplify API.graphql
monkeyPatchGraphqlCalls(gb)

//aws-config takes the place of "aws-exports" that Amplify CLI would generate
Amplify.configure(awsconfig)

ReactDOM.render(
  <GrowthBookProvider growthbook={gb}>
    <Provider store={store}>
      <App />
    </Provider>
  </GrowthBookProvider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
